module.exports = __webpack_public_path__ + "media/images/icon__point--default-26786efa03aeea83516e427bdefed636.png";